import React, { useState, useEffect } from "react";
import publicationService from "./../../../services/MarketingService/PublicationService";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Button } from "react-bootstrap";
import JSZip from "jszip";
import axios from "axios";
import PublicationFacebook from "./TypePublication/PublicationFacebook";
import PublicationInstagram from "./TypePublication/PublicationInstagram";
import "./publication.css";
// import ReactImageGrid from "facebook-image-grid";

function VoirPublication() {
  const [data, setData] = useState({});
  // const { id } = useParams();
  const [images, setImages] = useState([]);
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    fetchData();
    fetchPhotos();
  }, []);

  const fetchData = async () => {
    try {
      const response = await publicationService.getPublicationByID(localStorage.getItem("idPublication"));
      setData(response.data.success);
    } catch (error) {
      console.log(error);
    }
  };
  /**************** methode pour afficher les photos  **********************/

  const fetchPhotos = async () => {
    try {
      const responsePhotosId = await publicationService.getPublicationPhotosId(
        localStorage.getItem("idPublication")
      );
      setPhotos(responsePhotosId.data);
      const fetchedPhotos = await Promise.all(
        responsePhotosId.data.map(async (photoId) => {
          const responsePhotos = await publicationService.showImage(photoId);
          return responsePhotos;
        })
      );
      setImages(fetchedPhotos);
    } catch (error) {
      console.log(error);
    }
  };

  /**************** /.methode pour afficher les photos  **********************/

  /**************** methode pour telecharger les photos dans un fichier ZIP **********************/

  const fetchPhotosAndDownloadZip = async () => {
    try {
      const responsePhotosId = await publicationService.getPublicationPhotosId(
        localStorage.getItem("idPublication")
      );
      setPhotos(responsePhotosId.data);
      const fetchedPhotos = await Promise.all(
        responsePhotosId?.data.map(async (photoId) => {
          const responsePhotos = await publicationService.showImage(photoId);
          return responsePhotos;
        })
      );
      setImages(fetchedPhotos);

      // Création du dossier zip
      const zip = new JSZip();
      const folderName = "photos";
      const folder = zip.folder(folderName);

      // Téléchargement des images
      fetchedPhotos.forEach((photo, index) => {
        const currentTime = new Date().toISOString().replace(/[:.]/g, "_");
        const filename = `photo_${index + 1}_${currentTime}.jpeg`;
        axios({
          url: photo,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          // Ajout de l'image au dossier zip
          folder.file(filename, response.data, { binary: true });
          if (index === fetchedPhotos.length - 1) {
            // Génération du fichier zip et téléchargement
            zip.generateAsync({ type: "blob" }).then((content) => {
              const url = window.URL.createObjectURL(content);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${folderName}_${currentTime}.zip`);
              document.body.appendChild(link);
              link.click();
            });
          }
        });
      });
    } catch (error) {
      console.log(error);
    }
  };
  /**************** /.methode pour telecharger les photos dans un fichier ZIP **********************/
  return (
    <>
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <div className="content ">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <div className="card  mt-3">
                  <div className="card-body">
                    <h2 className="card-title">
                      Publication{" "}
                      <strong>
                        {data && data.canalDiffusion ? data.canalDiffusion : ""}
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}

        {/* content */}
        <section className="content">
          <div className="container-fluid">
            {data && data.canalDiffusion ? (
              data.canalDiffusion === "Facebook" ? (
                <PublicationFacebook id={localStorage.getItem("idPublication")} />
              ) : (
                <PublicationInstagram id={localStorage.getItem("idPublication")}/>
              )
            ) : null}

            <div className="row">
              {data && data.id ? (
                <div class="col col-sm">
                  <div className="card  mb-4">
                    <div className="card-header">
                      Contenu <strong>{data && data.nom}</strong>
                    </div>
                    <div className="card-body">
                      <ul>
                        <li>
                          <strong>Nom de l'Publication : </strong>
                          {data && data.nom ? data.nom : ""}
                        </li>
                        <li>
                          <strong>Objectif de l'Publication : </strong>
                          {data && data.objectif ? data.objectif : ""}
                        </li>
                        <li>
                          <strong>Contenu de l'Publication : </strong>
                          {data && data.contenu ? data.contenu : ""}
                        </li>
                        <li>
                          <strong>canal de diffusion : </strong>
                          {data && data.canalDiffusion
                            ? data.canalDiffusion
                            : ""}
                        </li>
                        <li>
                          <strong>Date de Publication : </strong>
                          {data && data.publicationDate
                            ? moment(data.publicationDate).format("YYYY-MM-DD")
                            : ""}{" "}
                          |<strong> Heure : </strong>
                          {data && data.publicationDate
                            ? moment(data.publicationDate).format("HH:mm:ss")
                            : ""}
                        </li>
                        <li>
                          <strong>Type de Publication : </strong>
                          {data && data.type ? data.type : ""}
                        </li>
                        <li>
                          <strong>Cible </strong>
                          <ul>
                            <li>
                              <strong>Age : </strong>
                              {data && data.ageCible ? data.ageCible : ""}
                            </li>
                            <li>
                              <strong>Lieu : </strong>
                              {data && data.lieuCible ? data.lieuCible : ""}
                            </li>
                            <li>
                              <strong>Genre : </strong>
                              {data && data.genreCible ? data.genreCible : ""}
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Statut de l'Publication : </strong>
                          {data && data.statut ? (
                            data.statut === "terminé" ? (
                              <span className="badge badge-danger">
                                {data.statut}
                              </span>
                            ) : data.statut === "encours" ? (
                              <span className="badge badge-primary">
                                {data.statut}
                              </span>
                            ) : data.statut === "planifié" ? (
                              <span className="badge badge-primary">
                                {data.statut}
                              </span>
                            ) : data.statut === "Rejeté" ? (
                              <span className="badge badge-secondary">
                                {data.statut}
                              </span>
                            ) : (
                              <span className="badge badge-success">
                                {data.statut}
                              </span>
                            )
                          ) : (
                            ""
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                "null"
              )}
              {images && images.length > 0 && data && data.id && (
                <div className="col col-sm">
                  <div className="card mb-4 ">
                    <div className="card-header">
                      Images <strong>{data && data.nom}</strong>
                      <div className="card-tools">
                        <Button
                          onClick={fetchPhotosAndDownloadZip}
                          variant="dark"
                        >
                          Télécharger les images
                        </Button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div style={{ maxWidth: 500, margin: "auto" }}>
                        {/* <ReactImageGrid
                          images={images}
                          style={{ width: 150 }}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default VoirPublication;
